<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Preview Advert"
      id="admin_preview_advert_edit_details"
    >
      <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Edit
      </v-btn>
      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        :disabled="is_loading"
        color="error"
        :to="'/admin/adverts/list/view/' + this.advert_id + '/delete'"
      >
        <v-icon left>mdi-trash-can</v-icon>
        Delete Ad
      </v-btn>
    </CardedSectionHeader>
    <AdvertView :advert="advert"></AdvertView>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Advert Edit Form"
      id="admin_advert_edit_form_from_add_view"
    >
    </CardedSectionHeader>
    <AdminAdvertsAdd
      :is_loading="is_loading"
      :is_editing="true"
      :advert_editing="advert"
      :key="this_advert_key"
      ref="admin_advert_add_view_ref"
      @on-show-loader="$emit('on-show-loader')"
      @on-hide-loader="$emit('on-hide-loader')"
      @on-success-edit-advert="on_success_edit_advert"
    >
    </AdminAdvertsAdd>
  </div>
</template>

<script>
import AdminAdvertsAdd from "./AdminAdvertsAdd";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import AdvertView from "../../../components/AdvertView";
export default {
  name: "AdminAdvertsEdit",
  components: {
    CardedSectionHeader,
    AdminAdvertsAdd,
    AdvertView
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      this_advert_key: "this_advert_key_1",
      this_advert_key_truck: 1,
      advert: Utils.get_default_advert(),
      advert_id: 0,
    };
  },
  methods: {
    load_advert() {
      this.$emit("on-show-loader");
      ServerClient.Adverts.get_advert_details(
        {
          id: this.advert_id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.advert = res;
          this.this_advert_key_truck = this.this_advert_key_truck + 1;
          this.this_advert_key =
            "this_advert_key_" + this.this_advert_key_truck;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading advert for editing in admin edit advert view",
            errors
          );
        }
      );
    },
    on_success_edit_advert() {
      this.load_advert();
    },
  },
  mounted() {
    this.advert_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Edit  Ad",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Adverts",
          disabled: false,
          href: "/admin/adverts",
        },
        {
          text: "list",
          disabled: false,
          href: "/admin/adverts/list",
        },
        {
          text: "view",
          disabled: false,
          href: "/admin/adverts/list/view/" + this.advert_id,
        },
        {
          text: "Edit",
          disabled: true,
          href: "/admin/adverts/list/view/" + this.advert_id + "/edit",
        },
      ],
    });
    this.load_advert();
  },
};
</script>